import styled from 'styled-components';

import { SectionGrid } from 'components/BackgroundInformation/styles';

export const StyledSectionGrid = styled(SectionGrid)`
  margin-top: 0px;
  align-content: flex-start;
`;

export const StyledRowTitle = styled.p`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 143%;
  letter-spacing: 0.17px;
  margin: 0;
  overflow-wrap: anywhere;
`;
